<p><a class="btn btn-primary btn-sm" [routerLink]="['/request/add', projectId]">Neue Anfrage</a></p>

<clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'request_id'" [clrDgSortOrder]="descSort">Anfrage</clr-dg-column>
    <clr-dg-column [clrDgField]="'requests_company'">Anfrage an</clr-dg-column>
    <clr-dg-column [clrDgField]="'subject'">Beschreibung</clr-dg-column>
    <clr-dg-column [clrDgField]="'purchasing_id'">Angebotsnummer</clr-dg-column>
    <clr-dg-column>Datum</clr-dg-column>
    <clr-dg-column>Fälligkeit</clr-dg-column>
    <clr-dg-column [clrDgField]="'purchasing_price'">Summe (netto)</clr-dg-column>
    <clr-dg-column>Status</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Request for Project {{ projectId }}!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let request of requests" [routerLink]="['/request/details', projectId, request.request_id]">
        <clr-dg-cell>{{ request.project_id }}.0001.{{ request.request_id }}</clr-dg-cell>
        <clr-dg-cell>{{ request.requests_company }}<br />({{ request.requests_salutation}} {{ request.requests_firstname }} {{ request.requests_lastname }})</clr-dg-cell>
        <clr-dg-cell><b>{{ request.subject }}</b></clr-dg-cell>
        <clr-dg-cell>{{ request.purchasing_id }}</clr-dg-cell>
        <clr-dg-cell>{{ request.requests_date | date: 'dd.MM.yyyy' }}</clr-dg-cell>
        <clr-dg-cell>{{ request.requests_submit | date: 'dd.MM.yyyy' }}</clr-dg-cell>
        <clr-dg-cell class="currency"><b>{{ request.purchasing_price | currency: 'EUR':'code':'1.2-2':'de'  }}</b></clr-dg-cell>
        <clr-dg-cell  [className]="findButtonClass(request.status)" role="alert">
            <div class="alert-items">
                <div class="alert-item static">
                    <span class="alert-text">{{ getCellStatus(request.status).statusDisplay}}</span>
                </div>
            </div>
        </clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="50">
            <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Anfragen pro Seite</clr-dg-page-size>
            {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
            von {{requests.length}} Anfrage(n)
        </clr-dg-pagination>
    </clr-dg-footer>
</clr-datagrid>
